import React, { useState, useEffect } from 'react';
import { Button, Row, Col } from "reactstrap";
import { VesselMachineryList } from './VesselConfiguration.model';
import apiGlobal from '../../global/api.global';
import SFOCRow from './SFOCRow';
import { useSelector } from 'react-redux';
import { RootState } from '../../';
import { fetchMachinaryOptions } from '../../VesselMaster/vesselMaster.hooks';
import { errorToast, successToast } from '../../Components/Toasts';
import { errResponse } from 'GenericForms/Helper';

const SFOC = () => {
    const [SFOCSetting] = useState<Array<any>>([]);
    const [vesselMachineries, setVesselMachineries] = useState<Array<VesselMachineryList>>([]);
    const { VesselID } = useSelector((state: RootState) => state.Reporting);

    useEffect(() => {
        const fetchData = async () => {
            await fetchMachinaryOptions(VesselID).then(res => {
                setVesselMachineries(res.data);
            }).catch(err => {
                if (errResponse.includes(err?.response?.status)) {
                    errorToast("Internal error occured, please contact the admin");
                }
            });
        };
        fetchData();
    }, [VesselID]);

    const SFOC_Submit = (e: any) => {
        SFOCSetting.map((setting: any) => (
            vesselMachineries.filter((item: any) => item.id === setting.id).map((machine: any, index: number) => {
                apiGlobal.patch(`/vessel_machinery_list/${machine.id}/`, SFOCSetting[index]).then(res => {
                    successToast("Data saved successfully!");
                }).catch(err => {
                    if (errResponse.includes(err.response.status)) {
                        errorToast("Internal error occured, please contact the admin");
                    }
                });
                return '';
            })
        ))
    }

    return (
        <>
            <Row>
                <Col>
                    <div className="table-responsive mb-5">
                        <table className="table">
                            <thead className="table-light">
                                <tr>
                                    <th>Sr. No.</th>
                                    <th>Machinery name</th>
                                    <th>SFOC</th>
                                    <th>EEDI/EEXI technical file</th>
                                    <th>NOx technical file</th>
                                </tr>
                            </thead>
                            <tbody>
                                {vesselMachineries && vesselMachineries.length > 0 ?
                                    vesselMachineries.filter((item: any) => item.sfoc_required === true).map((vesselMachinery: any, index: number) => {
                                        return (<SFOCRow key={`sfocrow-${index}`} SFOCSetting={SFOCSetting} vesselMachinery={vesselMachinery} index={index} />)
                                    }
                                    )
                                    : <tr>
                                        <td>Please add machinery to this vessel</td>
                                    </tr>}
                            </tbody>
                        </table>
                    </div>
                    <div className="d-flex flex-wrap btn_Margin">
                        <Button type="button" color='primary' className='pos-end' onClick={(e) => { SFOC_Submit(e) }}>Save</Button>
                    </div>
                </Col>
            </Row>
        </>
    )
}

export default SFOC;